import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Header from './components/Header';
import ProtectedRoute from './components/ProtectedRoute';
import LMSDashboard from './pages/LMSDashboard';
import Login from './pages/Login';
import Assessments from './pages/Assessments';
import Quiz from './pages/Quiz';
import Results from './pages/Results';
import Practical from './pages/Practical'; // Add this for Task 5
import AdminDashboard from './pages/AdminDashboard'; // Add this for Task 5
import ProtectedAdminRoute from './components/ProtectedAdminRoute'; // Add this for Task 5
import './App.css'; // Keep for global styles if needed

function App() {
  return (
    <Router>
      <AuthProvider>
        <Header />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/lms"
            element={
              <ProtectedRoute>
                <LMSDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Login />} />
          <Route
            path="/assessments"
            element={
              <ProtectedRoute>
                <Assessments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz/:category"
            element={
              <ProtectedRoute>
                <Quiz />
              </ProtectedRoute>
            }
          />
          <Route
            path="/practical"
            element={
              <ProtectedRoute>
                <Practical />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedAdminRoute>
                <AdminDashboard />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/results/:type?"
            element={
              <ProtectedRoute>
                <Results />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;




// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { AuthProvider } from './contexts/AuthContext';
// import Header from './components/Header';
// import ProtectedRoute from './components/ProtectedRoute';
// import LMSDashboard from './pages/LMSDashboard';
// import Login from './pages/Login';
// import Assessments from './pages/Assessments';
// import Quiz from './pages/Quiz'; // Add this
// import Results from './pages/Results'; // Add this
// import './App.css'; // Keep for global styles if needed

// function App() {
//   return (
//     <Router>
//       <AuthProvider>
//         <Header />
//         <Routes>
//           <Route path="/login" element={<Login />} />
//           <Route
//             path="/lms"
//             element={
//               <ProtectedRoute>
//                 <LMSDashboard />
//               </ProtectedRoute>
//             }
//           />
//           <Route path="/" element={<Login />} />
//           <Route
//             path="/assessments"
//             element={
//               <ProtectedRoute>
//                 <Assessments />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/quiz/:category"
//             element={
//               <ProtectedRoute>
//                 <Quiz />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/results/:category"
//             element={
//               <ProtectedRoute>
//                 <Results />
//               </ProtectedRoute>
//             }
//           />
//         </Routes>
//       </AuthProvider>
//     </Router>
//   );
// }

// export default App;







// import React, { useState } from 'react';
// import axios from 'axios';

// function App() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [message, setMessage] = useState('');

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await axios.post('/api/auth/login', { email, password });
//       setMessage(`Login successful! Token: ${res.data.token.substring(0, 20)}...`);
//       console.log(res.data); // Check in browser console
//     } catch (err) {
//       setMessage(err.response?.data?.msg || 'Error occurred');
//     }
//   };

//   const handleSignup = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await axios.post('/api/auth/signup', { email, password });
//       setMessage(`Signup successful! Token: ${res.data.token.substring(0, 20)}...`);
//       console.log(res.data);
//     } catch (err) {
//       setMessage(err.response?.data?.msg || 'Error occurred');
//     }
//   };

//   return (
//     <div style={{ padding: '20px', maxWidth: '400px', margin: 'auto' }}>
//       <h1>Assessment App - Test Auth</h1>
//       <form onSubmit={handleSignup}>
//         <h3>Signup</h3>
//         <input
//           type="email"
//           placeholder="Email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           required
//           style={{ display: 'block', margin: '10px 0', padding: '8px', width: '100%' }}
//         />
//         <input
//           type="password"
//           placeholder="Password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           required
//           style={{ display: 'block', margin: '10px 0', padding: '8px', width: '100%' }}
//         />
//         <button type="submit" style={{ padding: '10px', width: '100%' }}>Signup</button>
//       </form>
//       <form onSubmit={handleLogin}>
//         <h3>Login</h3>
//         <input
//           type="email"
//           placeholder="Email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           required
//           style={{ display: 'block', margin: '10px 0', padding: '8px', width: '100%' }}
//         />
//         <input
//           type="password"
//           placeholder="Password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           required
//           style={{ display: 'block', margin: '10px 0', padding: '8px', width: '100%' }}
//         />
//         <button type="submit" style={{ padding: '10px', width: '100%' }}>Login</button>
//       </form>
//       <p>{message}</p>
//     </div>
//   );
// }

// export default App;



// import React, { useState } from 'react';
// import axios from 'axios';

// function App() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [message, setMessage] = useState('');

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await axios.post('/api/auth/login', { email, password });
//       setMessage(`Login successful! Token: ${res.data.token.substring(0, 20)}...`);
//       console.log(res.data); // Check in browser console
//     } catch (err) {
//       setMessage(err.response?.data?.msg || 'Error occurred');
//     }
//   };

//   const handleSignup = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await axios.post('/api/auth/signup', { email, password });
//       setMessage(`Signup successful! Token: ${res.data.token.substring(0, 20)}...`);
//       console.log(res.data);
//     } catch (err) {
//       setMessage(err.response?.data?.msg || 'Error occurred');
//     }
//   };

//   return (
//     <div style={{ padding: '20px', maxWidth: '400px', margin: 'auto' }}>
//       <h1>Assessment App - Test Auth</h1>
//       <form onSubmit={handleSignup}>
//         <h3>Signup</h3>
//         <input
//           type="email"
//           placeholder="Email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           required
//           style={{ display: 'block', margin: '10px 0', padding: '8px', width: '100%' }}
//         />
//         <input
//           type="password"
//           placeholder="Password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           required
//           style={{ display: 'block', margin: '10px 0', padding: '8px', width: '100%' }}
//         />
//         <button type="submit" style={{ padding: '10px', width: '100%' }}>Signup</button>
//       </form>
//       <form onSubmit={handleLogin}>
//         <h3>Login</h3>
//         <input
//           type="email"
//           placeholder="Email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           required
//           style={{ display: 'block', margin: '10px 0', padding: '8px', width: '100%' }}
//         />
//         <input
//           type="password"
//           placeholder="Password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           required
//           style={{ display: 'block', margin: '10px 0', padding: '8px', width: '100%' }}
//         />
//         <button type="submit" style={{ padding: '10px', width: '100%' }}>Login</button>
//       </form>
//       <p>{message}</p>
//     </div>
//   );
// }

// export default App;





// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { AuthProvider } from './contexts/AuthContext';
// import Header from './components/Header';
// import ProtectedRoute from './components/ProtectedRoute';
// import LMSDashboard from './pages/LMSDashboard';
// import Login from './pages/Login';
// import './App.css'; // Keep for global styles if needed
// import Assessments from './pages/Assessments';  // Add this line
// // ... other imports

// function App() {
//   return (
//           <Routes>
//   <Route path="/login" element={<Login />} />
//   <Route
//     path="/lms"
//     element={
//       <ProtectedRoute>
//         <LMSDashboard />
//       </ProtectedRoute>
//     }
//   />
//   <Route path="/" element={<Login />} />
//   <Route
//     path="/assessments"
//     element={
//       <ProtectedRoute>
//         <Assessments />
//       </ProtectedRoute>
//     }
//   />
//   <Route
//     path="/quiz/:category"
//     element={
//       <ProtectedRoute>
//         <Quiz />
//       </ProtectedRoute>
//     }
//   />
//   <Route
//     path="/results/:category"
//     element={
//       <ProtectedRoute>
//         <Results />
//       </ProtectedRoute>
//     }
//   />
// </Routes>



// //     <Router>
// //       <AuthProvider>
// //         <Header />
// //         <Routes>
// //           <Route path="/login" element={<Login />} />
// //           <Route
// //             path="/lms"
// //             element={
// //               <ProtectedRoute>
// //                 <LMSDashboard />
// //               </ProtectedRoute>
// //             }
// //           />
// //           <Route path="/" element={<Login />} /> {/* Default to login */}
// //           {/* Placeholder for assessments */}
// //           <Route
// //             path="/assessments"
// //             element={
// //               <ProtectedRoute>
// //                 <div style={{ padding: '2rem' }}>
// //                   <h1>Assessments Coming Soon!</h1>
// //                   <p>MCQs and Practical Logic sections will be here.</p>
// //                 </div>
// //               </ProtectedRoute>
// //             }
// //           />
// //         </Routes>
// //       </AuthProvider>

// //             <Route path="/assessments" element={
// //   <ProtectedRoute>
// //     <Assessments />
// //   </ProtectedRoute>
// // } />
// // <Route path="/quiz/:category" element={
// //   <ProtectedRoute>
// //     <Quiz />
// //   </ProtectedRoute>
// // } />
// // <Route path="/results/:category" element={
// //   <ProtectedRoute>
// //     <Results />
// //   </ProtectedRoute>
// // } />

// //     </Router>

    
//   );
// }

// export default App;